import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import DalpakItemBlockData from 'Models/Content/DalpakItemBlockData';
import DalpakItemsBlockData from 'Models/Content/DalpakItemsBlockData';
import React, {useContext, useEffect, useState} from 'react';
import Bubbles, {Link} from './Bubbles';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import {useInView} from 'react-intersection-observer';
import TheCounterContext, {categoryFilterFunc} from 'app/Components/Page/TheCounterPage/TheCounterContext';
import classNames from 'classnames';

const DalpakItemsBlock = (props: ComponentProps<DalpakItemsBlockData>) => {
  const [animation, setAnimation] = useState(false);
  const [selectedCategory] = useContext(TheCounterContext) ?? [null];
  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const {operationBoxItems} = props.data;
  const [links, setLinks] = useState<Link[]>(null);
  useEffect(() => {
    if (!operationBoxItems?.expandedValue) return setLinks(null);

    const items = (operationBoxItems.expandedValue as DalpakItemBlockData[])
      .map((item, idx) => ({item, idx}))
      .filter(({item}) => categoryFilterFunc(item, selectedCategory))
      .map(({item: {link, linkTitle, itemPriority}, idx}) => ({
        idx,
        title: linkTitle.value,
        href: link.value,
        priority: itemPriority.value,
      }));

    setLinks(items);
  }, [operationBoxItems, selectedCategory]);

  return (
    <div className={classNames('DalpakItemsBlock', {animation})} ref={ref}>
      <BlockWrapper props={props} disableFadeIn>
        <Bubbles
          links={links}
          inView={inView}
          onAnimate={(active) => {
            const root = document.getElementById('epi-page-container');
            if (root) root.style.overflowX = active ? 'hidden' : '';
            setAnimation(active);
          }}
        />
      </BlockWrapper>
    </div>
  );
};

export default DalpakItemsBlock;
